import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { useIcon } from "../../../hooks/useIcon/index.mjs";
import { IconPersonSvg } from "./IconPersonSvg.mjs";
const IconPerson = (props) => {
  const iconProps = useIcon(props);
  return /* @__PURE__ */ jsx(Box, { component: IconPersonSvg, ...iconProps });
};
export {
  IconPerson
};
